import { useRouterState } from '@tanstack/react-router';
import { useMemo } from 'react';

import type { PageContext } from './assistant-api';

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const ENTITY_ROUTES: Array<[RegExp, NonNullable<PageContext['entityType']>]> = [
  [new RegExp(`^/customers/(${UUID})$`, 'i'), 'customer'],
  [new RegExp(`^/tasks/(${UUID})$`, 'i'), 'task'],
  [new RegExp(`^/quotes/(${UUID})$`, 'i'), 'quote'],
];

/** מסלול → הקשר לעוזר ("הלקוח הזה"). השרת מאמת את המזהה מול ה-DB. */
export function pageContextOf(pathname: string): PageContext {
  for (const [re, entityType] of ENTITY_ROUTES) {
    const m = re.exec(pathname);
    if (m?.[1]) return { path: pathname, entityType, entityId: m[1] };
  }
  return { path: pathname.replace(/[^A-Za-z0-9/_$.-]/g, '').slice(0, 200) || '/' };
}

export function usePageContext(): PageContext {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return useMemo(() => pageContextOf(pathname), [pathname]);
}
